import { createContext } from 'react';
import type { PublicConfig } from '@/api/types';

export interface TenantContextValue {
  config: PublicConfig;
  /** True on the platform console host (no tenant). */
  isPlatform: boolean;
  /** True on the public marketplace (directory of professionals). */
  isMarketplace: boolean;
  /** True on the brand site (bare domain): public pages only, no sign-in. */
  isLanding: boolean;
  /** Name to show in headers and titles: the tenant's, or the platform's. */
  displayName: string;
  /** Re-fetches the public config and rebuilds the theme (after brand edits). */
  refresh(): Promise<void>;
}

export const TenantContext = createContext<TenantContextValue | null>(null);

export function tenantContextValue(
  config: PublicConfig,
  refresh: () => Promise<void>,
): TenantContextValue {
  return {
    config,
    isPlatform: config.kind === 'platform',
    isMarketplace: config.kind === 'marketplace',
    isLanding: config.kind === 'landing',
    displayName: config.tenant?.displayName ?? config.platformName,
    refresh,
  };
}
